import z from "zod";

export const RegisterSchema = z.object({
  email: z.email("Invalid email").min(1, "Required email"),
  password: z
    .string()
    .min(1, "Required")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a number.",
    ),
  agreeToTerms: z.boolean().refine((v) => v === true, {
    message: "Please accept the Terms of Service and Privacy Policy to continue.",
  }),
});

export type RegisterFormValues = z.infer<typeof RegisterSchema>;
